import React, { Component } from "react";
import PropTypes from "prop-types";
import { Radio } from "cxa-components";
import { injectIntl, intlShape } from "react-intl";

class PlanFilter extends Component {
  constructor(props) {
    super(props);

    this.filterDidChange = this.filterDidChange.bind(this);
  }

  filterDidChange(e) {
    const filter = this.props.filters.find(
      item => item.planGroupName == e.target.value
    );

    this.props.onChange(filter);
  }

  render() {
    const { name, filters, currentFilter, intl } = this.props;

    const radioBoxes = filters.map((filter, index) =>
      <div key={index} className="apl-plan__filter">
        <Radio
          id={`${name}-${filter.filterName.replace(
            / /g,
            ""
          )}-${filter.filterId}`}
          name={name}
          value={filter.planGroupName}
          checked={filter.planGroupName === currentFilter}
          onChange={this.filterDidChange}
        >
          {intl.formatMessage({
            id: filter.messageKey,
            defaultMessage: filter.filterName,
          })}
        </Radio>
      </div>
    );

    return (
      <div className="cxa-c-form__field-box--inline">
        <fieldset>
          {radioBoxes}
        </fieldset>
      </div>
    );
  }
}

PlanFilter.propTypes = {
  filters: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  currentFilter: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(PlanFilter);



// WEBPACK FOOTER //
// ./components/employee/shop/PlanFilter.js